 //React imports
import React, { useEffect } from "react";

import FooterComponent from "../../components/home/FooterComponent.js";

//Imports assets such as images
import NavBarComponent from "../../components/navBar/NavBarComponent.js";
import CashbackVsDiscountsComponent from "../../components/solutions/cashbackInfo/cashbackVsDiscounts.jsx";
 import {Helmet} from "react-helmet";

export default function CashbackVsDiscountsPage() {
    return (
        <div>
            <div className="updated-page-wrapper">
                <div className="">

                    <NavBarComponent />
                </div>

                {/* <HeaderComponent page="pricing" /> */}


                <Helmet>
                    <title>Shopify Cashback vs Shopify Discount | Which is better for profit?</title>
                    <meta name="description" content="1 Shopify cashback vs 100 discounts: What's Better for Profitability?" />
                    <meta property="og:title" content="1 Shopify cashback vs 100 discounts: What's Better for Profitability?" />
                    <meta property="og:description" content="1 Shopify cashback vs 100 discounts: What's Better for Profitability?" />
                    <meta property="og:image" content="https://firebasestorage.googleapis.com/v0/b/pabloo-inc.appspot.com/o/pabloo%2Fmedia%2Fwebsite_media%2Fdiscount-strategy.webp?alt=media&token=4d2f6bf8-55b0-410a-a2fa-d6f3189e26e6" />
                </Helmet>

                <CashbackVsDiscountsComponent />




                <FooterComponent />
            </div>
        </div>
    );
}
